// @ts-nocheck

const certificatesItemsFunction = (certificatesItems) => {
  const certificates = document.querySelectorAll(".certificates-cards__item");
  for (let i = 0; i < certificates.length; i++) {
    const cert = certificates[i];
    console.log({ cert, certificates });
    cert.addEventListener("click", () => {
      document.querySelectorAll(".cert-modal-bg")[i].style.display = "flex";
      document
        .querySelectorAll(".cert-modal-close")
        [i].addEventListener("click", () => {
          document.querySelectorAll(".cert-modal-bg ")[i].style.display =
            "none";
        });
    });
  }
};


export { certificatesItemsFunction };
